import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackEvent } from './utils/amplitude';
import './LandingPage2.css';
import Footer from './Footer';

function LandingPage2() {
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return localStorage.getItem('isAuthenticated') === 'true';
    });
    const [waitlistEmail, setWaitlistEmail] = useState('');
    const [waitlistMessage, setWaitlistMessage] = useState('');
    const [showWaitlistModal, setShowWaitlistModal] = useState(false);

    useEffect(() => {
        trackEvent('page_viewed', { pageName: 'LandingPage2' });
    }, []);

    const handleGoogleSignup = () => {
        trackEvent('button_clicked', { buttonName: 'Google Signup', page: 'LandingPage2' });
        const backendUrl = process.env.NODE_ENV === 'production' 
            ? 'https://proto-backend-d2c1638486b9.herokuapp.com'
            : 'http://localhost:5000';
        window.location.href = `${backendUrl}/auth/google`;
    };

    const handleRequestAccess = () => {
        setShowWaitlistModal(true);
        trackEvent('request_access_clicked', { page: 'LandingPage2' });
    };

    const handleWaitlistSignup = async () => {
        if (!waitlistEmail) {
            setWaitlistMessage('Please enter a valid email.');
            return;
        }
    
        try {
            const response = await fetch('https://proto-backend-d2c1638486b9.herokuapp.com/join-waitlist', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: waitlistEmail }),
            });
    
            if (response.ok) {
                trackEvent('waitlist_signup', { email: waitlistEmail, page: 'LandingPage2' });
                setWaitlistMessage('Thank you for joining the waitlist!');
                setWaitlistEmail('');
                setTimeout(() => {
                    setShowWaitlistModal(false);
                    setWaitlistMessage('');
                }, 2000);
            } else {
                setWaitlistMessage('Failed to join the waitlist. Please try again.');
            }
        } catch (error) {
            console.error('Error joining waitlist:', error);
            setWaitlistMessage('An error occurred. Please try again.');
        }
    };

    return (
        <div className="landing-page-2">
            <div className="landing-container">
                {/* Hero Section - dark banner with two-line headline + inline icons */}
                <section className="hero-section hero-section-dark">
                    <h1 className="hero-headline-banner">
                        <span className="hero-line">
                            <span className="hero-word hero-word-white">From</span>{' '}
                            <span className="hero-word hero-word-orange">raw videos</span>{' '}
                            <span className="hero-icon-inline" aria-hidden="true">
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"/><line x1="7" y1="2" x2="7" y2="22"/><line x1="17" y1="2" x2="17" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/><line x1="2" y1="7" x2="7" y2="7"/><line x1="2" y1="17" x2="7" y2="17"/><line x1="17" y1="17" x2="22" y2="17"/><line x1="17" y1="7" x2="22" y2="7"/></svg>
                            </span>{' '}
                            <span className="hero-word hero-word-white">to</span>{' '}
                            <span className="hero-word hero-word-orange">final edit</span>
                        </span>
                        <span className="hero-line">
                            <span className="hero-word hero-word-white">in</span>{' '}
                            <span className="hero-icon-inline" aria-hidden="true">
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                            </span>{' '}
                            <span className="hero-word hero-word-orange">2 minutes</span>
                            <span className="hero-icon-inline" aria-hidden="true">
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
                            </span>
                        </span>
                    </h1>
                </section>

                {/* Features Section */}
                <section className="features-section">
                    <div className="features-content">
                        <h2 className="gradient-text section-title">
                            With a hook + script + voiceover (with your AI voice if you want) + subtitle + soundtrack.
                        </h2>
                        <p className="section-text">
                            You'll never have to edit again:
                            <br/>
                            If you're not satisfied with any aspect of the video (script, clips…),
                            <br/>
                            1 click to regenerate it.
                            <br/>
                            No editing. No prompting. No timeline.
                        </p>
                    </div>
                </section>

                {/* Example Video Section */}
                <section className="example-section">
                    <div className="example-content">
                        <h2 className="gradient-text section-title">
                            See Merra.ai in Action
                        </h2>
                        <p className="example-label">
                            This video was generated in few seconds with Merra.ai.
                            <br/>
                            Script, voiceover, editing, music, subtitles...
                        </p>
                        <div className="video-container">
                            <video
                                src="https://proto-filesharing.s3.eu-north-1.amazonaws.com/public/Example-New-GenerateVideoWithVoiceover-Merra-2.mp4"
                                controls
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '70vh',
                                    borderRadius: '12px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                }}
                                playsInline
                            >
                                <source src="https://proto-filesharing.s3.eu-north-1.amazonaws.com/public/Example-New-GenerateVideoWithVoiceover-Merra-2.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="cta-section">
                    <div className="cta-content">
                        <h2 className="gradient-text cta-title">
                            Ready to create?
                        </h2>
                        <div className="cta-buttons">
                            {isAuthenticated ? (
                                <button onClick={handleGoogleSignup} className="google-btn">
                                    <div className="google-icon" />
                                    Continue with Google
                                </button>
                            ) : (
                                <>
                                    <button onClick={handleGoogleSignup} className="google-btn">
                                        <div className="google-icon" />
                                        Continue with Google
                                    </button>
                                    <button onClick={handleRequestAccess} className="purple-button">
                                        <span>Request access</span>
                                        <span className="purple-button-shimmer"></span>
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </section>
            </div>

            {/* Waitlist Modal */}
            {showWaitlistModal && (
                <div
                    onClick={() => setShowWaitlistModal(false)}
                    className="modal-overlay"
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className="modal-content"
                    >
                        <button
                            onClick={() => setShowWaitlistModal(false)}
                            className="modal-close"
                        >
                            ×
                        </button>
                        <h2 className="gradient-text modal-title">
                            Get early access to Merra.ai
                        </h2>
                        <div className="field-wrapper">
                            <input
                                value={waitlistEmail}
                                onChange={(e) => setWaitlistEmail(e.target.value)}
                                placeholder="Your email"
                                type="email"
                                className="field"
                                required
                            />
                            <button
                                onClick={handleWaitlistSignup}
                                className="purple-button"
                            >
                                <span>Join waitlist</span>
                                <span className="purple-button-shimmer"></span>
                            </button>
                            {waitlistMessage && (
                                <p className={`waitlist-message ${waitlistMessage.includes('Thank you') ? 'success' : 'error'}`}>
                                    {waitlistMessage}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            )}
            <Footer />
        </div>
    );
}

export default LandingPage2;

